const { admin } = require("data/authData");

export const allowAccess = (role, user) => {
	if (user.role[role]) return true;
	if (user.role[admin]) return true;

	return false;
};
